var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VFormBuilder',{ref:"cupCode",attrs:{"items":_vm.items,"initial-values":_vm.initValues}})
}
var staticRenderFns = []

export { render, staticRenderFns }